import { render, staticRenderFns } from "./RoleAndPermission.vue?vue&type=template&id=5c13a71a&scoped=true&"
import script from "./RoleAndPermission.vue?vue&type=script&lang=js&"
export * from "./RoleAndPermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c13a71a",
  null
  
)

export default component.exports